<template>
  <v-dialog v-model="dialog" :persistent="true" max-width="900px">
    <v-card>
      <v-card-title class="justify-center">
        <span class="headline">Добавление нового отдела.</span>
      </v-card-title>

      <v-card-text>
        <v-form v-model="formValidation" ref="form" validation>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm12 md12>
                <v-text-field
                  v-model="departmentName"
                  :rules="[required]"
                  label="Название">
                </v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" flat @click.native="dialog = false">Закрыть</v-btn>
        <v-btn
          color="blue darken-1"
          flat @click.native="store"
          :disabled="!formValidation || loading"
          :loading="loading"
        >
          Сохранить
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    data() {
      return {
        dialog: false,
        departmentName: '',
        formValidation: false,
        required: value => !!value || 'Название не заполнено.'
      }
    },
    computed: {
      loading() {
        return this.$store.getters.loading;
      }
    },
    methods: {
      create() {
        this.$refs.form.reset()
        this.$refs.form.resetValidation()
        this.dialog = true
      },
      async store() {
        await this.$store.dispatch('saveDepartment', this.departmentName) ? this.dialog = false : ''
      }
    }
  }
</script>
